import { Component, Input, TemplateRef, OnInit, Output } from '@angular/core';
import { FNTabSelectEvent, FnTabModel } from './fn-tab.model';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'fn-tab',
    templateUrl: 'fn-tab.component.html',
    styleUrls: ['fn-tab.component.scss'],
})
export class FnTabComponent implements OnInit {
    @Input() tabArray: Array<FnTabModel> = [];
    @Input() dataTemplate: TemplateRef<HTMLElement>;
    @Input() isVertical: boolean;
    @Input() selectIndex: number;
    @Input() isMatStretchTabs: boolean = false;

    @Output() callback: EventEmitter<FNTabSelectEvent> = new EventEmitter();

    tabClass = '';

    ngOnInit(): void {
        this.tabClass = this.isVertical ? 'verticalTab' : 'horizontalTab';
    }
}
